module.exports = __webpack_public_path__ + "img/cooperation_unit_14.53c086dc.jpg";